<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0156 2.01172C14.6259 2.01172 17.0026 3.01184 18.7834 4.64979L15.9932 7.41081C14.9311 6.50662 13.5545 5.96094 12.0504 5.96094C8.68943 5.96094 5.96484 8.68552 5.96484 12.0465C5.96484 15.4074 8.68943 18.132 12.0504 18.132C14.7596 18.132 17.0553 16.3616 17.8438 13.9147H12.2734V10.2305H17.8603C17.8603 10.2304 17.8603 10.2303 17.8603 10.2303H21.8574C21.9614 10.8084 22.0156 11.4037 22.0156 12.0117C22.0156 17.5346 17.5385 22.0117 12.0156 22.0117C6.49278 22.0117 2.01562 17.5346 2.01562 12.0117C2.01562 6.48887 6.49278 2.01172 12.0156 2.01172Z"
      fill="#34A84A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5313 19.5763C20.6578 17.7424 22.0039 15.0285 22.0039 12.0002C22.0039 11.3936 21.9499 10.7995 21.8464 10.2227H17.8498L17.8498 10.2229H12.2656V13.9071H17.8308C17.3925 15.264 16.4907 16.4125 15.312 17.1661L18.5313 19.5763Z"
      fill="#4280F6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.7756 4.64979C16.9948 3.01184 14.6181 2.01172 12.0078 2.01172C8.09048 2.01172 4.69925 4.26415 3.05859 7.54452L6.30199 10.0216C7.13637 7.6561 9.39148 5.96094 12.0425 5.96094C13.5466 5.96094 14.9233 6.50662 15.9853 7.41081L18.7756 4.64979Z"
      fill="#EB3C35"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.01562 12.0157C2.01562 10.3984 2.39952 8.87089 3.08115 7.51917L6.32241 9.99023C6.09097 10.6336 5.96484 11.3273 5.96484 12.0504C5.96484 12.7376 6.07875 13.3982 6.28872 14.0144L3.09154 16.5327C2.40342 15.1759 2.01562 13.6411 2.01562 12.0157Z"
      fill="#FDBD05"
    />
    <rect
      x="13.5"
      y="13.5"
      width="10.5"
      height="10.5"
      rx="5.25"
      fill="#4A24AC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.5303 16.7197C21.8232 17.0126 21.8232 17.4874 21.5303 17.7803L18.5303 20.7803C18.2374 21.0732 17.7626 21.0732 17.4697 20.7803L15.9697 19.2803C15.6768 18.9874 15.6768 18.5126 15.9697 18.2197C16.2626 17.9268 16.7374 17.9268 17.0303 18.2197L18 19.1893L20.4697 16.7197C20.7626 16.4268 21.2374 16.4268 21.5303 16.7197Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "RbToGoogleAndReviewIcon"
};
</script>
